module.exports = __webpack_public_path__ + "img/greenReadingScience2.9f6ef7d1.png";